const debugOutput = false;

/**
 * Pushes an event to the data layer
 *
 * @param {string} event - The event name
 * @param {Object} payload - The payload to be sent with the event
 * @returns {void}
 */
function pushToDataLayer(event, payload) {
  // Make sure data layer is available
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  // Loop through the payload and set '-' as value if the value is empty
  for (let key in payload) {
    if (
      !payload[key] ||
      payload[key] === "" ||
      payload[key] === "null" ||
      payload[key] === "undefined"
    ) {
      payload[key] = "-";
      return;
    }
    // Clean the value of the property
    payload[key] = cleanPropertyValue(payload[key]);
  }
  // Add the page URL withouth the query parameters to the payload
  payload.pageUrl = window.location.origin + window.location.pathname;
  // Log to console if debugOutput is set to true
  if (debugOutput) {
    console.log({ event, ...payload });
  }
  // Push to data layer
  window.dataLayer.push({
    event: event,
    ...payload,
  });
}

/**
 * Clean the value of a property. This removes any newlines, tabs, and
 * multiple spaces. It also trims the value and gets rid of any html
 * tags.
 *
 * @param {string} value - The value to clean
 * @returns {string} The cleaned value
 */
function cleanPropertyValue(value) {
  return value
    .replace(/\s+/g, " ")
    .replace(/[\n\r\t]/g, "")
    .replace(/<[^>]*>?/gm, "")
    .trim();
}

export { pushToDataLayer };
